<div class="prose mx-auto px-4 py-6">
	<div class="text-center">
		<h5>
			<b> POLÍTICA DE PRIVACIDADE TXM METHODS </b>
		</h5>

		<p><i> (Versão 1.0) </i></p>
	</div>
	<p>
		O presente documento tem por finalidade demonstrar o compromisso que a TXM
		Methods tem com a privacidade e a proteção dos dados pessoais coletados de
		seus cocreators, clientes, fornecedores e parceiros, de acordo com as leis
		em vigor.
	</p>
	<p>
		A TXM Methods trata com seriedade a privacidade, tornando-se uma questão
		prioritária. Por isso, levamos ao conhecimento de todos a forma como
		cuidamos dos dados pessoais, incluindo procedimentos que visam assegurá-la.
	</p>
	<p>
		Esta política se aplica também ao COCREATIONLAB, e em geral, a todos aqueles
		que possuem algum tipo de relação com a TXM Methods, sejam cocreators,
		potenciais cocreators, colaboradores, parceiros ou fornecedores, entre
		outros.
	</p>
	<p>
		Nossa Política de Privacidade é pautada pela Lei Geral de Proteção de Dados
		Pessoais (LGPD), nº 13.709/2018.
	</p>
	<p><b> CONCEITOS BÁSICOS </b></p>
	<p>
		<b>Política de privacidade:</b> conjunto de regras estabelecidas para garantir
		a segurança necessária às informações cadastradas ou coletadas, por qualquer
		meio, fundamentais para o melhor oferecimento de nossa missão.
	</p>
	<p>
		<b>Dado Pessoal:</b> é o dado relativo a uma pessoa física que seja capaz de
		identifica-la ou tornar possível sua identificação. São exemplos de Dados Pessoais
		que permitem a sua identificação: nome, CPF, RG, endereço, telefone celular,
		e-mail, etc.
	</p>
	<p>
		<b>Dado Sensível:</b> é qualquer informação sobre origem racial ou étnica, convicção
		religiosa, opinião política, filiação a sindicato ou organização de caráter religioso,
		filosófico ou político, saúde ou vida sexual, dado genético ou biométrico, quando
		vinculado à uma pessoa natural.
	</p>
	<p>
		<b>Encarregado:</b> é o nosso Encarregado de Proteção de Dados Pessoais (DPO),
		que atua como canal de comunicação entre a TXM Methods, os titulares dos dados
		e a Autoridade Nacional de Proteção de Dados (ANPD), quando o assunto é a proteção
		dos Dados Pessoais.
	</p>
	<p>
		<b>Serviços TXM Methods:</b> são todos os produtos, serviços, metodologia, negócios,
		experiências e jornada de cocriação e mentorias oferecidas pelo Cocreation Lab,
		voltados a construir e potencializar negócios.
	</p>
	<p>
		<b>Informação Compartilhada TXM Methods e Parceiros:</b> visa a uniformidade
		em troca de informações com o objetivo de comunicação com as instituições parceiras
		que regem o objetivo do negócio, além da disseminação das boas práticas, resultando
		na maior eficácia operacional.
	</p>
	<p><b>COLETA DE DADOS E SUA FINALIDADE</b></p>
	<p>
		Para fazer uso dos serviços/produtos TXM Methods, tendo acesso aos eventos
		aos conteúdos, e às vantagens oferecidas aos Cocreators, é necessário
		inscrever-se em um dos formulários/editais disponíveis no site
		http://www.cocreationlab.com.br/editais/. As informações coletadas nestes
		formulário/editais são armazenadas em local seguro.
	</p>
	<p>
		Estas informações são utilizadas para avaliação das ideias de negócio, bem
		como do proponente e demais membros da equipe. Tais informações são
		compartilhadas com os avaliadores parceiros do programa, entre a equipe
		executiva e gestores locais, e em alguns casos, com as instituições
		parceiras. Estas informações são parcialmente divulgadas no site
		http://www.cocreationlab.com.br/editais/ para finalidade de informação das
		propostas selecionadas em cada etapa do edital.
	</p>
	<p>
		A TXM Methods não solicita, não possui acesso e nem armazena informações
		financeiras ou dados bancários, já que não envolve nenhum custo em seus
		processos para os participantes. A forma de inscrição em editais ou eventos
		está estruturada para coleta de informações necessárias somente para
		identificação, a fim garantir a segurança de todos os processos realizados.
	</p>
	<p>
		Para viabilizar a entrega dos serviços/produtos, o site, a plataforma, o
		chat, ou outros meios operados, através de seus formulários, podem solicitar
		a você alguns dados cadastrais como, por exemplo, nome completo, número de
		inscrição no CPF, e-mail, endereço e etc.
	</p>
	<p>
		Algumas das informações indicadas acima deverão ser obrigatoriamente
		fornecidas para aprimorar e garantir a entrega dos nossos serviços/produtos,
		bem como, cumprir exigências estabelecidas pelos órgãos regulatórios que
		auditem e fiscalizem as operações da TXM Methods.
	</p>
	<p>
		No momento do seu cadastro (on-line ou presencial), você disponibilizará
		seus contatos pelos quais a TXM Methods e o Cocreation Lab utilizarão com a
		única finalidade de comunicá-lo sobre os nossos serviços/produtos,
		possibilidade de divulgação, oportunidades exclusivas, necessidades da
		pré-incubação e outras oportunidades que puderem ser do seu interesse.
	</p>
	<p>
		Uma vez inscrito, você porá receber informações e usufruirá de todo o nosso
		portfólio com divulgação de serviços/produtos, etc. Após o termino da
		pré-incubação você poderá optar por interromper o recebimento de mensagens
		que não estejam vinculadas a necessidades do lab de ideação.
	</p>
	<p>
		Adicionalmente, sempre com o objetivo de aprimorar os serviços e viabilizar
		a entrega dos mesmos, a plataforma TXM.Business e o site do CocreationLab
		poderá coletar e armazenar quaisquer informações sobre sua navegação em
		nossos sites como, por exemplo:
	</p>
	<p>
		Identificação de dispositivo;<br />
		Endereços IP e MAC de dispositivos;<br />
		Recursos ou páginas utilizadas;<br />
		Recursos ou páginas acessadas;<br />
		Tempo de permanência/utilização dos recursos;<br />
		Eventuais erros ocorridos e seus detalhamentos.
	</p>
	<p>
		Qualquer informação pessoal exibida que não foi diretamente informada por
		você, pode ter sido obtida em razão da gestão compartilhada com nossos
		parceiros, observando as finalidades especificas esclarecidas no item
		“Compartilhamento” da presente Política de Privacidade.
	</p>
	<p>
		Salientamos que, a qualquer momento, você poderá solicitar a atualização do
		seu cadastro.
	</p>
	<p>
		Em relação aos dados pessoais de nossos colaboradores, representantes,
		parceiros ou fornecedores, coletamos apenas aqueles indispensáveis ao
		atendimento da legislação, órgãos fiscalizadores das atividades, políticas
		públicas ou execução dos ajustes realizados entre as partes.
	</p>
	<p><b> ARMAZENAMENTO E SEGURANÇA </b></p>
	<p>
		Todos os dados coletados são armazenados em bancos de dados próprios ou de
		segurança implementada (prestadora de serviços em nuvem), o que aumenta a
		segurança das informações coletadas. As informações disponíveis em modo
		offline (sem acesso à internet) são armazenadas de forma segura, com acesso
		a usuários chave dos processos.
	</p>
	<p>
		Seguindo algumas premissas que buscam garantir a confidencialidade, a
		integridade e o controle do acesso aos dados coletados como, por exemplo:
		controlar o acesso às informações, considerando a necessidade de nossos
		colaboradores obterem determinado dado; proteger infraestruturas
		tecnológicas contra acessos não autorizados; monitorar constantemente toda
		nossa infraestrutura tecnológica; política de troca de senhas; política de
		confidencialidade com funcionários e terceiros, etc.
	</p>
	<p>
		A TXM.Methods armazena as informações coletadas para finalidade específica
		de acompanhamento da evolução dos projetos após a fase de pré-incubação,
		para finalidades de pesquisa e desenvolvimento, e para melhoria dos seus
		processos e serviços, além de qualquer outra razão para sua manutenção como,
		por exemplo, cumprimento de quaisquer obrigações legais, regulatórias,
		contratuais, entre outras, desde que plenamente embasadas e fundamentadas,
		conforme legislação pertinente.
	</p>
	<p><b> USO DAS INFORMAÇÕES </b></p>
	<p>
		Em relação aos cocreators e potenciais cocreators, as informações coletadas
		são para aprimoramento e concretização dos nossos produtos/serviços. Elas
		permitem o estudo de suas preferências e o oferecimento de uma experiência
		mais próxima de seus interesses. Para os colaboradores, parceiros e
		fornecedores, a utilização se dá de acordo com as determinações dos órgãos
		fiscalizadores e legislação existente.
	</p>
	<p><b> COMPARTILHAMENTO </b></p>
	<p>
		Para que possamos criar melhores oportunidades para nossos cocreators, e
		prestar serviços com excelência, operamos em parcerias com outras entidades,
		sendo necessário, para tanto, o compartilhamento de alguns dados.
	</p>
	<p>
		Esse compartilhamento de Dados Pessoais sempre é realizado buscando
		preservar ao máximo a sua privacidade e, sempre que possível, de forma
		anônima.
	</p>
	<p>
		Além disso, estas ações de compartilhamento envolvem apenas empresas e
		parceiros diretamente relacionados com a prestação dos serviços que
		demonstrem estar em conformidade com as leis aplicáveis e mesmos fins
		indicados na presente Política, bem como, mantenham um nível de conformidade
		semelhante ou, até mesmo, mais rigoroso do que o previsto na legislação
		aplicável.
	</p>
	<p>
		A TXM Methods também compartilhará os Dados, quando necessário, em
		decorrência de obrigação legal, determinação de autoridade competente ou por
		decisão judicial.
	</p>
	<p>
		Os Dados Pessoais que coletamos não são transferidos para outros países.
	</p>
	<p><b>COOKIES E TECNOLOGIAS SEMELHANTES</b></p>
	<p>
		Os sites disponibilizados pela TXM Methods e CocreationLab, poderão utilizar
		cookies e tecnologias semelhantes, com autorização prévia nas páginas de
		internet que são referenciadas. Cookies são pequenos pacotes de dados que
		são enviados para o navegador e ficam armazenados em seu dispositivo, que
		nos permitem entender melhor o comportamento dos visitantes, além de
		contribuir para a eficácia na distribuição de conteúdo.
	</p>
	<p>
		A maior parte dos navegadores são predefinidos para aceitarem cookies de
		forma automática. Nas configurações do seu navegador é possível alterar
		isso. Saiba, no entanto, que com os cookies desativados, algumas
		funcionalidades do site podem não funcionar da forma adequada.
	</p>
	<p>Tipos de cookies</p>
	<p>
		Cookies estritamente necessários - Sempre ativos - Estes cookies são
		necessários para que o website funcione e não podem ser desligados nos
		nossos sistemas. Normalmente, eles só são configurados em resposta a ações
		levadas a cabo por si e que correspondem a uma solicitação de serviços, tais
		como definir as suas preferências de privacidade, iniciar sessão ou
		preencher formulários. Pode configurar o seu navegador para bloquear ou
		alertá-lo(a) sobre esses cookies, mas algumas partes do website não
		funcionarão. Estes cookies não armazenam qualquer informação pessoal
		identificável.
		<br /><br />
		Cookies de funcionalidade - Estes cookies permitem que o site forneça uma funcionalidade
		e personalização melhoradas. Podem ser estabelecidos por nós ou por fornecedores
		externos cujos serviços adicionamos às nossas páginas. Se não permitir estes
		cookies algumas destas funcionalidades, ou mesmo todas, podem não atuar corretamente.
		<br /><br />
		Cookies de desempenho - Estes cookies permitem-nos contar visitas e fontes de
		tráfego, para que possamos medir e melhorar o desempenho do nosso website. Eles
		ajudam-nos a saber quais são as páginas mais e menos populares e a ver como os
		visitantes se movimentam pelo website. Todas as informações recolhidas por estes
		cookies são agregadas e, por conseguinte, anônimas. Se não permitir estes cookies,
		não saberemos quando visitou o nosso site.
		<br /><br />
		Cookies de publicidade - Estes cookies podem ser estabelecidos através do nosso
		site pelos nossos parceiros de publicidade. Podem ser usados por essas empresas
		para construir um perfil sobre os seus interesses e mostrar-lhe anúncios relevantes
		em outros websites. Eles não armazenam diretamente informações pessoais, mas
		são baseados na identificação exclusiva do seu navegador e dispositivo de internet.
		Se não permitir estes cookies, terá menos publicidade direcionada.
	</p>
	<p><b> CONTATO E ESCLARECIMENTO DE DÚVIDAS </b></p>
	<p>
		Caso tenha dúvidas, sugestões ou comentários relacionados a esta Política
		e/ou seus Dados Pessoais, entre em contato conosco.
	</p>
	<p>ENCARREGADO: Luiz Carlos de Freitas Junior</p>
	<p>
		Contato através do:
		<a href="mailto:compliance@cocreationlab.com.br"
			>compliance@cocreationlab.com.br</a
		>, e-mail com o assunto e dúvida ou solicitação.
	</p>
	<p><b> POLÍTICA DE PROTEÇÃO DE DADOS COM PARCEIROS </b></p>
	<p>
		Este Termo será aplicado em todas as atuações da
		<b>TXM METHODS E COCREATIONLAB</b> com os parceiros que realizarem conveniamentos.
	</p>
	<p>
		Poderá ser aprimorada a atuação de Proteção de Dados da
		<b>TXM METHODS E COCREATIONLAB</b> por intermédio do aproveitamento das regras
		dos parceiros.
	</p>
	<p><b> MUDANÇAS NA POLÍTICA DE PRIVACIDADE </b></p>
	<p>
		Para assegurar a qualidade das informações e normativas, a TXM Methods
		poderá, sempre que necessário e a qualquer tempo, alterar esta Política de
		Privacidade. Sendo assim, recomendamos sua consulta periodicamente, bem
		como, a data de atualização informada abaixo.
	</p>
	<p>
		A TXM Methods reitera seu compromisso de buscar sempre o melhor para
		proteger os interesses e direitos de seus Cocreators, colaboradores,
		parceiros e fornecedores.
	</p>
	<p><i> Última atualização: 21/06/2021 </i></p>
	<p><b> LEI APLICÁVEL E JURISDIÇÃO </b></p>
	<p>
		A presente Política de Privacidade e Tratamento de Dados Pessoais deve ser
		regida e interpretada segundo a legislação brasileira, no idioma português,
		sendo eleito o Foro da Capital/Santa Catarina para dirimir qualquer litígio
		ou controvérsia envolvendo o presente documento, salvo ressalva específica
		de competência pessoal, territorial ou funcional pela legislação aplicável.
	</p>
	Responsável:<br />
	<address>
		LUIZ CARLOS DE FREITAS JUNIOR<br />
		<a href="mailto:compliance@cocreationlab.com.br"
			>compliance@cocreationlab.com.br</a
		>
	</address>
	22/06/2021
</div>

<svelte:head>
	<title>TXM Business | Política de privacidade</title>
</svelte:head>
